import { AnimationProps } from '../types'

const exitAnimation: AnimationProps = {
  animate: { scale: 0.92 },
  initial: { scale: 1 },
  transition: {
    default: {
      duration: 0.3,
      ease: [0, 0.7, 0.2, 1],
    },
    scale: {
      damping: 1,
      ease: 'linear',
      restDelta: 0.001,
      stiffness: 100,
      type: 'spring',
    },
  },
}

const animations = {
  exitAnimation,
}

export { animations }
